import React, { useState } from 'react'
import AInvbasicDetail from '../../invoices/components/AInvbasicDetail'
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { addInvoiceApi } from '../../invoices/apiService'
import { globalPostService } from '../../../utils/globalApiServices'
import { checkApiStatus, normalizeTaxRate } from '../../../utils'
import { useSnackbar } from 'notistack'
import { PageLoader } from '../../../shared_elements'
import moment from 'moment'
import { setFileUploadDetails, setUploadFiles } from '../../../shared_elements/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { trackActivity } from '../../../utils/mixpanel'

const AddCreditDebitNote = ({ onToggleModal, modeType, item, addEditInvoice, leaseSlug }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [linkedInv, setLinkedInv] = useState(addEditInvoice?.data);
    const { enqueueSnackbar } = useSnackbar();
    const [tableErrors, setTableErrors] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const [error, setError] = useState({});
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    
    const onAddEditInvoice = () => {

        let validationInputs = {
            invoice_number: linkedInv?.invoice_number?.trim()?.length ? '' : 'Please enter Invoice Number',
            date: linkedInv?.date ? '' : 'Please enter Invoice Date',
            due_date: linkedInv?.due_date ? '' : 'Please enter Invoice Due Date',
            bank: linkedInv?.bank?.id ? '' : 'Please select Bank',
        }

        const invoiceDate = moment(linkedInv?.date);
        const dueDate = moment(linkedInv?.due_date);
        if (linkedInv?.date && linkedInv?.due_date) {
            if (dueDate.isBefore(invoiceDate)) {
                validationInputs.due_date = "Due Date cannot be before Invoice Date";
            }
            if (invoiceDate.isAfter(dueDate)) {
                validationInputs.date = "Invoice Date cannot be after Due Date";
            }
            if (invoiceDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.date = "Invoice Date cannot be before Lease Start Date";
			}
			if (invoiceDate.isAfter(leaseBasicDetails?.end_date)) {
				validationInputs.date = `Invoice Date cannot be after Lease End Date`;
			}
			if (dueDate.isAfter(leaseBasicDetails?.end_date)) {
				validationInputs.due_date = "Due Date cannot be after Lease End Date";
			}
			if (dueDate.isBefore(leaseBasicDetails?.start_date)) {
				validationInputs.due_date = "Due Date cannot be before Lease Start Date";
			}
            if (linkedInv?.due_date && !dueDate.isValid()) {
                validationInputs.due_date = "Please enter valid Due Date";
            }
            if (linkedInv?.date &&!invoiceDate.isValid()) {
                validationInputs.date = "Please enter valid Invoice Date";
            }
        }

        // ----------------Item Table Condition-----------
        let newErrors = {};
        linkedInv.invoice_items.forEach((row, index) => {
            const errors = {};

            if (!row.description?.trim()) {
                errors.description = "Please enter Description";
            }

            if (!row.sub_total || parseFloat(row.sub_total) <= 0) {
                errors.sub_total = "Please enter Amount";
            }

            if (linkedInv?.invoice_type?.label === 'Credit Note Invoice') {
                if (row.sub_total > row.original_amount) {
                    errors.sub_total = "Credit Amount can't exceed Original Amount ";
                }
            }

            if (Object.keys(errors).length > 0) {
                newErrors[index] = errors;
            }
        });

        setTableErrors(newErrors)
        if (!Object.keys(validationInputs).every((k) => validationInputs[k] === '') || Object.keys(newErrors).length > 0) {
            setError({ ...validationInputs });
            trackActivity(`Item Added`, { page_title: 'Add ' + linkedInv?.invoice_type?.label, error_msg: validationInputs, })
            return;
        }
        setLoading(true);
        const normalizedItems = linkedInv.invoice_items.map(item => ({ ...item, tax_rate: normalizeTaxRate(item?.tax_rate) }));
        globalPostService(addInvoiceApi(), {...linkedInv, invoice_items: normalizedItems, asset:leaseBasicDetails?.asset, lease_slug:leaseBasicDetails?.slug, currency: linkedInv?.currency?.code, })
            .then(async (response) => {
                if (checkApiStatus(response)) {
                    if (attachments?.length) {
                        dispatch(setUploadFiles({ modal: true, slug: response?.data?.data?.slug }));
                    }
                    setLoading(false);
                    onToggleModal()
                    trackActivity('Item Added', { page_title: 'Add ' + linkedInv?.invoice_type?.label, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: linkedInv, response: response?.data })
                    navigate(`/invoices/view/${response?.data?.data?.slug}`, { state: { from: 'viewFromLease' } })
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
                    trackActivity('Item Added', { page_title: 'Add ' + linkedInv?.invoice_type?.label, error_msg: response?.data?.message, item_id: null, payload: linkedInv, response: response?.data })
                }
            })
    };

    const onFieldChange = (keyParam, value, invoiceItem, itemIndex) => {
        if (invoiceItem) {
            if (keyParam === "sub_total" || keyParam === "tax_rate") {
                let taxAmount = 0;
                let subTotal = 0;

                if (keyParam === "sub_total") {
                    subTotal = parseFloat(value) || 0;
                    if (linkedInv.invoice_items[itemIndex].tax_rate) {
                        taxAmount = subTotal * (parseFloat(linkedInv.invoice_items[itemIndex].tax_rate) / 100);
                    }
                } else {
                    subTotal = parseFloat(linkedInv.invoice_items[itemIndex].sub_total) || 0;
                    if (value) {
                        taxAmount = subTotal * (parseFloat(value) / 100);
                    }
                }

                const subAmountTotal = subTotal + taxAmount;

                setLinkedInv({
                    ...linkedInv,
                    invoice_items: linkedInv.invoice_items.map((item, index) =>
                        index !== itemIndex
                            ? item
                            : {
                                ...item,
                                [keyParam]: value,
                                tax_amount: taxAmount.toFixed(4),
                                sub_amount_total: subAmountTotal.toFixed(4),
                            }
                    ),
                });
            } else {
                setLinkedInv({
                    ...linkedInv,
                    invoice_items: linkedInv.invoice_items.map((item, index) =>
                        index !== itemIndex ? item : { ...item, [keyParam]: value }
                    ),
                });
            }
        } else {
            setLinkedInv({ ...linkedInv, [keyParam]: value });
        }
    };

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const resetTableError = (rowIndex, fieldName) => {
        setTableErrors((prevErrors) => {
            const rowErrors = { ...prevErrors[rowIndex] };
            delete rowErrors[fieldName];

            const updatedErrors = { ...prevErrors };
            if (Object.keys(rowErrors).length === 0) {
                delete updatedErrors[rowIndex];
            } else {
                updatedErrors[rowIndex] = rowErrors;
            }

            return updatedErrors;
        });
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Add ' + linkedInv?.invoice_type?.label, page_type: page_type, })
    }
    
    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='lg'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header' id="customized-dialog-title">
                    Add {linkedInv?.invoice_type?.label ? linkedInv?.invoice_type?.label : (linkedInv?.is_credit_note === 'true' ? 'Credit Note' : 'Debit Note')}
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <AInvbasicDetail leaseSlug={leaseSlug} addEditInvoice={item} type={'reconcileInvoice'} modeType={modeType} onFieldChange={onFieldChange} onRestErrorKey={onRestErrorKey} invoice={linkedInv} error={error} tableErrors={tableErrors} resetTableError={resetTableError} handleFileChange={handleFileChange} />
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel </Button>
                    <Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditInvoice(); }}>
                        {isLoading ? <CircularProgress color='inherit' size={25} /> : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}

export default AddCreditDebitNote